<template>
  <div>
    <div><a @click.stop.prevent="detailFun">详情</a></div>
  </div>
</template>

<script>
// import HandlerResTool from './resHandlerCommon';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'DetailTemplate',
  components: {

  },
  data() {
    return {
      data: {},
      url: '/lte/ems/',
    };
  },
  methods: {
    detailFun() {
      // 区分服务和实例-----idFlag:oamType_flag flag=0,服务，flag=1,实例
      const valueList = this.data.idFlag.split('_');
      // const oper = new HandlerResTool();
      // const param = {
      //   load: this.$loading,
      //   $axios: this.$axios,
      //   tipFlag: true
      // };
      if (valueList[0] === '0') { // 服务查看详情
        this.openServerDetailPage();
        // param.callFun = this.openServerDetailPage;
        // param.url = `${this.url}server/queryOne/-2`;
      } else if (valueList[0] === '1') { // 实例查看详情
        this.openDeployedDetailPage();
        // param.url = `${this.url}deployed/queryOne`;
        // param.callFun = this.openDeployedDetailPage;
      }
      // oper.$GetRequest(param);
    },
    openServerDetailPage() {
      EventBus.$emit('openDetailPage', { serviceId: this.data.serviceId, deployedCount: this.data.deployedCount });
    },
    openDeployedDetailPage() {
      EventBus.$emit('openDetailPage', this.data.serviceId);
    },
  },
};
</script>

<style scoped>

</style>
